function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.167 18.36c.46 0 .833-.373.833-.834v-4.193h2.5c.46 0 .833-.373.833-.833v-10a.833.833 0 00-.833-.833h-15a.833.833 0 00-.833.833v10c0 .46.373.833.833.833h7.13l3.894 4.724a.833.833 0 00.643.303zM3.333 3.333h13.334v8.334h-3.334v3.539l-2.917-3.54H3.333V3.334z"
});

var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20"
  }), _ref);
};

export default SvgMessage;